import { AccountRole } from '@/data/usecases/account/account-role'
import { AccountCompanyModel } from '@/domain/models/account/account-company-model'
import { AccountPersonalProfileModel } from '@/domain/models/account/account-personal-profile-model'
import { AccountProfileModel } from '@/domain/models/account/account-profile-model'
import { GenericResponse } from '@/infra/http'
import {
  AccountAddonModel,
  AccountBasicModel,
  AccountModel
} from '../../models/account/account-model'
import { AccountAnonymous } from './account-anonymous'
import { AccountBenefit } from './account-benefit'

export interface Account {
  get(): Promise<Account.Model>
  loaderGet(): Promise<Account.Model>
  profile(): Promise<Account.ProfileModel>
  updateProfile(accountProfile: Account.ProfileModel): Promise<GenericResponse<void>>
  loader(): Promise<Account.ProfileModel>
  updatePersonalProfile(accountProfile: AccountPersonalProfileModel): Promise<GenericResponse<void>>
  updatePicture(accountId: string, file: File): Promise<Account.PictureModel>
  removePicture(accountId: string): Promise<void>
  getBenefits(accountId: string): Promise<AccountBenefit.Model>
}

export namespace Account {
  export type Model = AccountModel
  export type BasicModel = AccountBasicModel
  export type ProfileModel = AccountProfileModel
  export type CompanyModel = AccountCompanyModel
  export type PersonalProfileModel = AccountPersonalProfileModel
  export type PictureModel = { pictureUrl: string }
  export type AddonModel = AccountAddonModel

  export const Key = 'account'
  export const ProfileKey = 'account-profile'
  export const UpdateProfileKey = 'update-account-profile'
  export const PictureKey = 'account-picture-key'

  export const isAnonymous = (accountProfile: Account.Model) =>
    accountProfile.id === AccountAnonymous.ID
  export const getAnonymous = () => AccountAnonymous.Model
  export const hasPassPlan = (accountProfile: Account.Model) => accountProfile.passPlan !== null
  export const isInternalCompanyManager = (accountProfile: Account.Model) =>
    AccountRole.contains(AccountRole.Enum.INTERNAL_COMPANY_MANAGER, accountProfile.roles)
  export const isCompanyManager = (accountProfile: Account.Model) =>
    AccountRole.contains(AccountRole.Enum.COMPANY_MANAGER, accountProfile.roles)
  export const isDependentUser = (accountProfile: Account.Model) =>
    AccountRole.contains(AccountRole.Enum.USER_DEPENDENT, accountProfile.roles)
}
